import { Select } from "@aclymatepackages/atoms";

import { batteryTypes } from "@aclymatepackages/products";

const BatteryTypesSelect = ({
  batteryType = "",
  setBatteryType,
  label = "Select a Battery Type",
  ...otherProps
}) => {
  return (
    <Select
      label={label}
      options={batteryTypes.map(({ label, type }) => ({ label, value: type }))}
      value={batteryType}
      editValue={setBatteryType}
      {...otherProps}
    />
  );
};

export default BatteryTypesSelect;
